<template>
  <SysDialog
    v-model="DIALOG_ATIVO"
    :titulo="`Relatório ${relatorio.title}`"
    txt-botao="Gerar relatório"
    :largura="700"
    @click:primary="gerarRelatorio"
  >
    <div class="pb-2">
      <SysFilialGrupoAutocomplete
        v-model="filtros.filiais"
        label="Filial"
        outlined
        multiple
        hide-details
      />

      <div class="d-flex align-center">
        <div class="w-50-porcento pr-2">
          <SysSegmentoAutocomplete
            v-model="filtros.segmentos"
            label="Segmentos"
            outlined
            multiple
            hide-details
            class="mt-4"
          />
        </div>

        <div class="w-50-porcento pl-1">
          <SysSecaoAutocomplete
            v-model="filtros.secoes"
            label="Seções"
            outlined
            multiple
            hide-details
            class="mt-4"
          />
        </div>
      </div>

      <div class="d-flex align-center">
        <div class="w-50-porcento pr-2">
          <SysCategoriaAutocomplete
            v-model="filtros.categorias"
            label="Categorias"
            outlined
            multiple
            hide-details
            class="mt-4"
          />
        </div>

        <div class="w-50-porcento pl-1">
          <SysFornecedorAutocomplete
            v-model="filtros.fornecedores"
            label="Fornecedores"
            outlined
            multiple
            :ids-segmento="filtros.segmentos"
            hide-details
            class="mt-4"
          />
        </div>
      </div>
    </div>

    <form
      :action="URL_RELATORIO"
      method="post"
      target="_blank"
      ref="submit-form-relatorio-analise-por-lote"
    >
      <input type="text" hidden name="filtros" :value="JSON.stringify(filtros)" />
    </form>
  </SysDialog>
</template>

<script>
import $axios from "@/api/api";
import Mixin from "@/components/Relatorios/Mixin";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete.vue";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete.vue";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete.vue";
import SysSecaoAutocomplete from "@/components/utils/crud/SysSecaoAutocomplete.vue";
import SysCategoriaAutocomplete from "@/components/utils/crud/SysCategoriaAutocomplete.vue";

export default {
  name: "Exemplo",
  mixins: [Mixin],
  components: {
    SysFilialGrupoAutocomplete,
    SysSegmentoAutocomplete,
    SysFornecedorAutocomplete,
    SysSecaoAutocomplete,
    SysCategoriaAutocomplete
  },
  data: () => ({
    filtros: {
      filiais: [],
      segmentos: [],
      fornecedores: [],
      secoes: [],
      categorias: []
    }
  }),
  computed: {
    URL_RELATORIO() {
      return `${$axios.defaults.baseURL}/${this.relatorio.url}`;
    }
  },
  methods: {
    gerarRelatorio() {
      this.$refs['submit-form-relatorio-analise-por-lote'].submit();
      this.DIALOG_ATIVO = false;
    }
  }
}
</script>

<style scoped>

</style>
